/**
 * Модуль заявки в лист ожидания
 * Используется на странице психолога, когда нет свободных слотов
 */
const Waitlist = {
	moduleId: 2, // тот же mod_psy

	personId: null,
	personName: '',
	isAuthenticated: false,

	init: function() {
		this.checkAuth();
		this.initPopupClose();
	},

	initPopupClose: function() {
		const popup = document.getElementById('popup-waitlist');
		if (!popup) return;

		popup.addEventListener('click', (e) => {
			if (e.target === popup || e.target.classList.contains('popup__wrapper')) {
				this.close();
			}
		});

		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && popup.classList.contains('active')) {
				this.close();
			}
		});
	},

	/**
	 * Открытие попапа
	 * @param {number} personId - ID психолога
	 * @param {string} personName - ФИО психолога для отображения
	 */
	open: function(personId, personName) {
		const popup = document.getElementById('popup-waitlist');
		if (!popup) return;

		this.reset();
		this.personId = personId;
		this.personName = personName || '';

		document.getElementById('waitlist-person-id').value = personId;
		document.getElementById('waitlist-psy-name').textContent = this.personName;

		// Проверяем авторизацию и показываем/скрываем подсказку
		this.checkAuth();
		this.updateAuthState();

		popup.classList.add('active');
		document.body.style.overflow = 'hidden';
	},

	close: function() {
		const popup = document.getElementById('popup-waitlist');
		if (popup) {
			popup.classList.remove('active');
			document.body.style.overflow = '';
		}
	},

	reset: function() {
		this.personId = null;
		this.personName = '';
		this.clearError();

		const notes = document.getElementById('waitlist-notes');
		if (notes) {
			notes.value = '';
			notes.classList.remove('popup-waitlist__notes-input--error');
		}

		// Восстанавливаем контент попапа, если он был заменён экраном успеха
		const card = document.querySelector('.popup-waitlist__card');
		if (card && card.dataset.originalHtml) {
			card.innerHTML = card.dataset.originalHtml;
			delete card.dataset.originalHtml;
		}
	},

	checkAuth: function() {
		const clientEl = document.querySelector('[data-client-id]');
		if (clientEl) {
			this.isAuthenticated = true;
			return;
		}

		// fetch для подстраховки (асинхронно)
		const formData = new FormData();
		formData.append('mid', this.moduleId);
		formData.append('action', 'check_auth');

		fetch('/ajax.php', { method: 'POST', body: formData })
			.then(r => r.json())
			.then(data => {
				this.isAuthenticated = data.authenticated || false;
				this.updateAuthState();
			})
			.catch(() => { this.isAuthenticated = false; });
	},

	updateAuthState: function() {
		const authRequired = document.getElementById('waitlist-auth-required');
		const btn = document.getElementById('waitlist-btn-submit');
		if (!authRequired || !btn) return;

		if (this.isAuthenticated) {
			authRequired.style.display = 'none';
			btn.textContent = 'Оставить заявку';
		} else {
			authRequired.style.display = '';
			btn.textContent = 'Войти и оставить заявку';
		}
	},

	/**
	 * Открыть авторизацию, после успеха — вернуться в попап и отправить
	 */
	showAuthAndSubmit: function() {
		this.close();

		if (!window.Auth) return;

		Auth.openAuthPopup();

		const onAuth = () => {
			document.removeEventListener('authSuccess', onAuth);
			this.isAuthenticated = true;

			setTimeout(() => {
				const popup = document.getElementById('popup-waitlist');
				if (popup) {
					popup.classList.add('active');
					document.body.style.overflow = 'hidden';
					this.updateAuthState();
				}
			}, 500);
		};

		document.addEventListener('authSuccess', onAuth);
	},

	submit: function() {
		this.clearError();

		// Если не авторизован — открываем авторизацию
		if (!this.isAuthenticated) {
			this.showAuthAndSubmit();
			return;
		}

		const notesEl = document.getElementById('waitlist-notes');
		const btn = document.getElementById('waitlist-btn-submit');

		const notes = (notesEl && notesEl.value || '').trim();
		if (notes.length < 5) {
			if (notesEl) {
				notesEl.classList.add('popup-waitlist__notes-input--error');
				notesEl.focus();
			}
			this.showError('Пожалуйста, опишите коротко, что вас беспокоит (минимум 5 символов)');
			return;
		}
		if (notesEl) notesEl.classList.remove('popup-waitlist__notes-input--error');

		if (btn) {
			btn.disabled = true;
			btn.textContent = 'Отправка...';
		}

		const formData = new FormData();
		formData.append('mid', this.moduleId);
		formData.append('action', 'create_waitlist');
		formData.append('person_id', this.personId);
		formData.append('notes', notes);

		fetch('/ajax.php', { method: 'POST', body: formData })
			.then(r => r.json())
			.then(data => {
				if (data.success) {
					this.onSuccess(data);
				} else if (data.need_profile) {
					this.showProfileRequired();
				} else {
					this.showError(data.error || 'Не удалось отправить заявку');
					if (btn) {
						btn.disabled = false;
						btn.textContent = 'Оставить заявку';
					}
				}
			})
			.catch(() => {
				this.showError('Ошибка соединения');
				if (btn) {
					btn.disabled = false;
					btn.textContent = 'Оставить заявку';
				}
			});
	},

	/**
	 * Показать сообщение о необходимости заполнить профиль
	 * Срабатывает после первого SMS-входа, когда ФИО ещё пусты
	 */
	showProfileRequired: function() {
		const card = document.querySelector('.popup-waitlist__card');
		if (!card) return;

		// Сохраняем текущее значение textarea, чтобы не потерять при подмене HTML
		const notesEl = document.getElementById('waitlist-notes');
		if (notesEl) this.savedNotes = notesEl.value;

		if (!card.dataset.originalHtml) {
			card.dataset.originalHtml = card.innerHTML;
		}

		card.innerHTML = `
			<div class="popup-waitlist__success">
				<div class="popup-waitlist__success-title">Заполните профиль</div>
				<div class="popup-waitlist__success-text">
					<p>Чтобы оставить заявку, нужно указать имя и фамилию в профиле.</p>
				</div>
				<a class="popup-waitlist__btn popup-waitlist__btn--primary" href="/profile/" target="_blank" rel="noopener">Перейти к профилю</a>
				<button class="popup-waitlist__btn popup-waitlist__btn--secondary" onclick="Waitlist.restoreForm()" style="margin-left:8px">Вернуться к заявке</button>
			</div>
		`;
	},

	/**
	 * Восстановить форму заявки после возврата с заполнения профиля
	 */
	restoreForm: function() {
		const card = document.querySelector('.popup-waitlist__card');
		if (!card || !card.dataset.originalHtml) return;

		card.innerHTML = card.dataset.originalHtml;
		delete card.dataset.originalHtml;

		// Восстанавливаем имя психолога и ID
		const idInput = document.getElementById('waitlist-person-id');
		const nameEl = document.getElementById('waitlist-psy-name');
		if (idInput) idInput.value = this.personId;
		if (nameEl) nameEl.textContent = this.personName;

		// Восстанавливаем введённый ранее комментарий
		const notesEl = document.getElementById('waitlist-notes');
		if (notesEl && this.savedNotes) {
			notesEl.value = this.savedNotes;
		}

		// Разблокируем кнопку отправки
		const btn = document.getElementById('waitlist-btn-submit');
		if (btn) {
			btn.disabled = false;
			btn.textContent = 'Оставить заявку';
		}

		this.updateAuthState();
		this.clearError();
	},

	onSuccess: function(data) {
		const card = document.querySelector('.popup-waitlist__card');
		if (!card) return;

		// Сохраняем оригинальный HTML, чтобы при повторном открытии форма вернулась
		if (!card.dataset.originalHtml) {
			card.dataset.originalHtml = card.innerHTML;
		}

		card.innerHTML = `
			<div class="popup-waitlist__success">
				<div class="popup-waitlist__success-icon">✓</div>
				<div class="popup-waitlist__success-title">Заявка принята!</div>
				<div class="popup-waitlist__success-text">
					<p>Мы свяжемся с вами, как только у психолога ${this.personName} появится свободное время.</p>
				</div>
				<button class="popup-waitlist__btn popup-waitlist__btn--secondary" onclick="Waitlist.close()">Закрыть</button>
			</div>
		`;

		document.dispatchEvent(new CustomEvent('waitlistSuccess', { detail: data }));

		if (window.Lead) Lead.reachGoal('waitlist_submit');
	},

	showError: function(message) {
		const el = document.getElementById('waitlist-error');
		if (el) {
			el.textContent = message;
			el.style.display = '';
		}
	},

	clearError: function() {
		const el = document.getElementById('waitlist-error');
		if (el) {
			el.textContent = '';
			el.style.display = 'none';
		}
	}
};

document.addEventListener('DOMContentLoaded', function() {
	Waitlist.init();
});

window.Waitlist = Waitlist;
